import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import { Section } from 'sa-ui';

import messages from './configurationMessages';
import ConfigurationForm from './ConfigurationForm';
import * as actions from './configurationActions';

const ConfigurationContainer = ({ user, canEdit, ...props }) => {
  return (
    <Section title={<FormattedMessage {...messages.title} />}>
      {user && (
        <ConfigurationForm
          onSubmit={props.save}
          user={user}
          onUpload={props.upload}
          onRemove={props.removePhoto}
          isLoading={props.isLoading}
          userInfo={props.userInfo}
          userInfoStatus={props.userInfoStatus}
          intl={props.intl}
          canEdit={canEdit}
        />
      )}
    </Section>
  );
};

ConfigurationContainer.propTypes = {
  intl: intlShape.isRequired,
};

const mapStateToProps = ({ app, configuration }) => ({
  user: app.user,
  userInfo: configuration.userInfo,
  userInfoStatus: configuration.userInfoStatus,
  isLoading: configuration.isLoading,
  canEdit: app.canEditSchool,
  ...app,
});

export default compose(connect(mapStateToProps, actions), injectIntl)(ConfigurationContainer);
